<template>
  <div>
    <el-card class="chart-card">
      <h1>PignooWriter - 数据操作器</h1>
      <p>
        <el-text>PignooWriter是PignooReader的子接口，所以PignooWriter中可以使用PignooReader的全部方法。</el-text>
        <br />
        <el-text>PignooWriter是一个数据操作集，用于增、删、改数据。</el-text>
        <br />
        <el-text>PignooWriter与PignooReader一样参考java.util.List与java.util.stream.Stream的操作方式。</el-text>
        <br />
        <el-text tag="b">PignooWriter是为操作而生的。即使是读操作，也是为操作数据而读的！</el-text>
      </p>
      <p>
        <el-text>下面着重介绍它与Reader不同的地方。</el-text>
      </p>
      <h1>操作函数</h1>
      <p>
        <el-text>PignooWriter中增加了用于操作数据的函数。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code1 }}</code></pre>
      </div>
      <p>
        <el-text tag="b">注意：当执行“ById”操作时，之前的filter条件依然生效！</el-text>
        <el-text>也就是说，指定的ID不在过滤范围内，将无法操作！</el-text>
      </p>
      <h1>PignooWriter的“锁”</h1>
      <p>
        <el-text>查询加锁行为只在事务场景下生效，且需要数据库引擎的支持。</el-text>
      </p>
      <p>
        <el-text>操作数据库时，我们经常需要先查询，在查询基础上进行更新。但如果忘记在查询时加锁，面临多线程操作时，就会有“脏读”问题。</el-text>
        <el-text>于是，在PignooWriter在进行读取操作时，为读取到的数据增加了“写锁”，防止在读取后，其他线程读取或修改此数据。</el-text>
        <el-text>所以说，PignooWriter的读是具有排他性的，读出来的数据是奔着要修改去的。</el-text>
        <el-text tag="b">writer的查询是为修改而做的查询！如果只是为了读取数据，请使用reader！</el-text>
      </p>
      <p>
        <el-text>实现原理，就是在SELECT的同时增加了“写锁”，例如MySQL的SELECT ... FOR UPDATE。</el-text>
        <el-text>在使用getAny这类单一元素查询时，会不加锁查询出一条数据，再通过ID加锁，以保证加的是“行锁”。</el-text>
        <el-text>在使用getAll这类多元素查询时，是“行锁”还是“表锁”完全根据筛选条件交给数据库处理，这也是最符合业务需要的做法。</el-text>
      </p>
      <h1>PignooWriter的“动态代理”（setter代理功能）</h1>
      <p>
        <el-text>是否使用setter代理功能，是可以在PignooConfig中做配置的。</el-text>
        <el-text tag="b">默认开启。</el-text>
      </p>
      <p>
        <el-text>PignooWriter的“动态代理”是指使用writer查询到的JavaBean，是经过了一次动态代理的。</el-text>
        <el-text tag="b">在代理中，setter方法都被映射了数据库操作！</el-text>
        <el-text>这也就达成了【入门】篇章中newPig.setName("换个名字")的操作能直接操作数据库的效果。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code2 }}</code></pre>
      </div>
      <p>
        <el-text>setter代理功能构成了“Pignoo用List操作还原数据库操作”的重要一环，也是Pignoo易用性有限的重要体现。</el-text>
        <el-text>Pignoo集合与JVM集合构成了一个泾渭分明的体系：</el-text>
        <el-text>PignooReader是完全指代数据库的集合，List是完全指代JVM内存的集合；</el-text>
        <el-text>JavaBeanProxy是完全指代持久化数据的对象，它必须是从PignooWriter中取出的；</el-text>
        <el-text>PignooWriter的get方法，是将指代持久化数据的对象，提取到了JVM的集合中。</el-text>
      </p>
      <p>
        <el-text>setter代理也引入了两个牺牲性能的地方：</el-text>
        <el-text>同一个对象多次调用setter，会执行多次SQL，执行效率明显不如mix和replace；</el-text>
        <el-text>查询时，要为每个JavaBean创建代理，执行效率略逊。</el-text>
        <el-text>因此，是否开启代功能理需要提前规划好！需要在意执行效率的项目，建议关闭setter代理功能。</el-text>
      </p>
      <h1>copyReader、copyWriter、isReadOnly</h1>
      <p>
        <el-text>前面已经了解过PignooReader的copyReader方法，其实还有一个copyWriter方法。</el-text>
        <el-text>通过这两个方法，同查询条件下的Reader与Writer可以相互转化。</el-text>
      </p>
      <p>
        <el-text>由于PignooWriter是PignooReader的子接口，所以使用多态时，可以将writer赋值到一个reader变量。</el-text>
        <el-text>这时想要明确区分一个PignooReader变量（其实可能是个PignooWriter实现）是否为只读，可以使用isReadOnly方法。</el-text>
      </p>
      <p>
        <el-text>有时，使用传参的PignooReader，担心传入的是个PignooWriter从而误操作了数据？</el-text>
        <el-text>也可以通过copyReader明确得转为只读器。</el-text>
      </p>
      <h1>写操作强依赖于ID</h1>
      <p>
        <el-text>再次强调。Pignoo操作数据时，很多场景强依赖于ID。Pignoo要求：</el-text>
        <el-text tag="b">所有的实体必须有且只有一个ID；ID的名字、数据类型可以随意；ID必须是唯一的；ID必须是非空的；不允许修改ID。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code3 }}</code></pre>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  if (window.hljs) {
    window.hljs.highlightAll()
  }
})

const code1 = `gru.runTransaction(pignoo -> { // 写操作一般放在事务中
  PignooWriter writer = pignoo.writer(Pig.class).filter(...);
  
  writer.add(pig); // 新增一条数据
  writer.pollAny(); // 取出并移除任一条数据（实际上会忽略排序条件，以更高效的方式查询满足条件的一个）
  writer.pollFirst(); // 取出并移除第一条数据
  writer.mixById(pig); // 根据ID，将数据“并入”已有数据（更新非NULL的属性）
  writer.mixAll(pig); // 将满足当前过滤条件的数据全部做“并入”更新
  writer.replaceById(pig); // 根据ID，将数据“替换”已有数据（更新全部属性，含NULL）
  writer.replaceAll(pig); // 将满足当前过滤条件的数据全部做“替换”更新
  writer.removeById(pig); // 根据ID，移除数据
  writer.removeAll(); // 移除当前条件下的全部数据
});`

const code2 = `Pig pig = writer.filter(Pig::getId, "==", 3L).getAny();
pig.setName("新名字");`

const code3 = `Pig pig = writer.filter(Pig::getId, "==", 3L).getAny();
pig.setId(4L); // 错误！Pignoo不允许修改ID`

</script>

<style lang="less"></style>